<template>
  <div :class="classes">
    <div class="tg-services--trigger" @click="handleTogglerServiceBtn"></div>
    <div class="tg-services--wrapper">
      <div
        class="tg-services--btn"
        :class="{ opening: open }"
        @click="handleWrapperClick"
      >
        <span>
          <i class="tg-icon tg-icon-services-white"></i>
        </span>
      </div>
      <div class="tg-services--group" v-show="open">
        <tg-qrcode-btn
          v-if="wechat"
          ref="wechatBtn"
          size="3x"
          channel="WeChat"
          label="wechat"
          :image="wechat.serviceUrl"
        ></tg-qrcode-btn>
        <tg-qrcode-btn
          v-if="qq"
          ref="qqBtn"
          size="3x"
          channel="qq"
          :label="qqLabel"
          :image="qq.serviceUrl"
        ></tg-qrcode-btn>
        <div>
          <span @click="handleClick">
            <i class="tg-icon tg-icon-circle tg-icon-serviceOnline24"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TgQrcodeBtn from "./TgQrcodeBtn";
import { on, off } from "element-ui/src/utils/dom";

export default {
  name: "TgServiceBtn",
  components: {
    TgQrcodeBtn,
  },
  data() {
    return {
      title: "",
      open: false,
      active: false,
    };
  },
  props: {
    wechat: {
      type: Boolean,
      default: false,
    },
    qq: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return [
        "tg-services--toggler",
        {
          active: this.active,
        },
      ];
    },
    qqLabel() {
      return this.$t("component.service.qq");
    },
  },
  methods: {
    handleTogglerServiceBtn() {
      this.active = !this.active;
    },
    handleDocumentClick(e) {
      if (
        this.$el.contains(e.target) ||
        (this.$refs.wechatBtn && this.$refs.wechatBtn.$el.contains(e.target)) ||
        (this.$refs.qqBtn && this.$refs.qqBtn.$el.contains(e.target))
      ) {
        return;
      }

      this.open = false;
      this.active = false;
    },
    handleClick() {
      this.$store.dispatch("service/showService", this.$user);
    },
    handleWrapperClick() {
      this.open = !this.open;
    },
  },
  mounted() {
    on(document, "click", this.handleDocumentClick);
  },
  destroyed() {
    off(document, "click", this.handleDocumentClick);
  },
};
</script>
